import { render, staticRenderFns } from "./newJobLogs.vue?vue&type=template&id=23b43cd8&scoped=true"
import script from "./newJobLogs.vue?vue&type=script&lang=js"
export * from "./newJobLogs.vue?vue&type=script&lang=js"
import style0 from "./newJobLogs.vue?vue&type=style&index=0&id=23b43cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b43cd8",
  null
  
)

export default component.exports